module.exports = __webpack_public_path__ + "img/goFunDetail.80bab710.png";